
import React from 'react';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { TerraceFormValues } from "./types";

const terraceCategoryOptions = [
  { value: "restaurant", label: "Restaurant" },
  { value: "bar", label: "Bar" },
  { value: "cafe", label: "Café" },
  { value: "food_court", label: "Food Court" },
  { value: "rooftop", label: "Rooftop" },
  { value: "hotel", label: "Hotel" },
  { value: "other", label: "Other" },
];

interface TerraceTypeSelectProps {
  form: UseFormReturn<TerraceFormValues>;
  disabled?: boolean;
}

const TerraceTypeSelect: React.FC<TerraceTypeSelectProps> = ({ form, disabled = false }) => {
  return (
    <FormField
      control={form.control}
      name="type"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Type *</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            value={field.value}
            disabled={disabled}
          >
            <FormControl>
              <SelectTrigger className={disabled ? "bg-muted text-muted-foreground" : ""}>
                <SelectValue placeholder="Select type" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {terraceCategoryOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {disabled && (
            <FormDescription>
              This will be filled automatically from the Google Maps link
            </FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default TerraceTypeSelect;
